<template>
  <slice
    :id="block._key"
    class="slice--cta-text container"
    :class="{ 'only-button': !hasText }"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="description__content">
      <portable-text
        v-if="hasText"
        :blocks="block.text"
        class="description__text"
      />

      <div v-if="link" class="d-flex justify-center mt-2">
        <div>
          <primary-button
            :type="block.btn_link.type === 'internal' ? 'nuxt-link' : 'link'"
            :to="link"
            :href="link"
            :text="block.btn_label"
            align="center"
            :with-arrow="block.btn_arrow"
            :target="block.btn_link.blank ? '_blank' : '_self'"
          />
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'
import PrimaryButton from '@/components/buttons/Primary'

export default {
  name: 'BlockCtaText',
  components: { Slice, PortableText, PrimaryButton },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    hasText() {
      return this.block.text && this.block.text.length > 0
    },
    link() {
      if (this.block.btn_link.type === 'internal') {
        if (
          !this.block.btn_link.internalLink ||
          this.block.btn_link.internalLink.uid === null
        ) {
          return null
        }

        return this.$contextSanityPath(this.block.btn_link.internalLink)
      }

      return this.block.btn_link.url
    },
  },
}
</script>

<style lang="scss">
.slice--cta-text {
  .description {
    &__content {
      max-width: rem(720px);
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
  }

  &.layout--full {
    .description__content,
    .rich-text {
      max-width: none;
    }
  }
}
</style>
